import DashboardService from '../services/dash.service';
const DEBUG=true;


export const dash = {
  namespaced: true,
  state: { 
    db: [],
    totalRecordCount: 0,
    searchSPZ: '',
    searchOTHER: '',
    daysBack: 0, // 1: yesterday 0:today
    filter: 2,
    isLoading: false,
    dashID: 0, // dash.id of clicked row
    appLog: null,
    wrkLog: null,
    errorMessage: '',
    categoryCheck: {
        spz: null,
        flotila: 'Arval'
    },
    tabControl: {
        offset: 0,
        limit: 10,
        order: 'id',
        sort: 'desc',
    },
    action: null, // akce button will fill dashID
  },

  getters: {
    getDB:            (state) => state.table,
    //getSearchSPZ:     (state) => state.searchSPZ,
    getTotalRecordCount: (state) => state.totalRecordCount,
    getAppLogs:       (state) => state.appLogs,
    getWrkLogs:       (state) => state.wrkLogs,
    //getTable()     { return this.table; },
//    getCurrentUser(state, getters, rootState, rootGetters) {
//        return rootGetters['auth/currentUser'];
//    },
  },

  actions: {
    fetchData({ commit, state, rootGetters }) {
      commit('setIsLoading', true);
      const currUser = rootGetters['auth/currentUser'];
      if(DEBUG) console.log('Store -> running DashboardService.fetch for spz', state.searchSPZ);
      return DashboardService.fetch({
        user: currUser,
        spz:  state.searchSPZ,
        other: state.searchOTHER,
        daysBack: state.daysBack,
        filter: state.filter,
        tabControl: state.tabControl
      })
      .then(
        response => {
            commit('setIsLoading', false);
            commit('setDB', response.table);
            commit('setTotalRecordCount', response.totalRows);

            if(DEBUG) console.debug(`Store -> Dashboard fetched ${response.table?.length} records.`)
            return Promise.resolve(response.table);
        },
        error => {
            commit('setIsLoading', false);
            commit('setErrorMessage', error);
            commit('setDB',[]);
            return Promise.reject(error);
        }
      );
    },

    fetchLogs({ commit, state, rootGetters }, dashID) {
      if(dashID) commit('setDashID', dashID);
      if(state.dashID===0) return;
      const currUser = rootGetters['auth/currentUser'];
      return DashboardService.fetchLogs({
        user:    currUser,
        dashID:  state.dashID,
      })
      .then(
        response => {
            commit('setLogs', response);
            if(DEBUG) console.debug(`Store -> Dashboard logs fetched ${response.appLog?.length} and ${response.wrkLog?.length} records.`);
            return Promise.resolve(response);
        },
        error => {
            commit('setLogs', {appLog: [], wrkLog: []});
            commit('setErrorMessage', error);
            return Promise.reject(error);
        }
      );
    },

    runAction({ commit, state, rootGetters }, {action, dashID, payload}) {
      console.log(`dash.store -> runAction received ${action} for dashID: ${dashID}`);
      commit('setDashID', dashID);
      commit('setAction', action);
      const currUser = rootGetters['auth/currentUser'];
      return DashboardService.runAction({
        user:    currUser,
        action:  state.action,
        dashID:  state.dashID,
        data:    payload || null,
      })
      .then(
        response => {
            //commit('setLogs', response);
            if(DEBUG) console.debug(`Store -> Dashboard runAction finished.`);
            return Promise.resolve(response);
        },
        error => {
            //commit('setLogs', {appLog: [], wrkLog: []});
            commit('setErrorMessage', error);
            return Promise.resolve(error);
        }
      );
    },

    adminCommand({ commit, rootGetters }, {jobID, command, payload}) {
      console.log(`dash.store -> adminCommand received jobID:${jobID} command: ${command} payload: ${JSON.stringify(payload)}`);
      const currUser = rootGetters['auth/currentUser'];
      return DashboardService.adminCommand({
        user:    currUser,
        jobID:   jobID,
        command: command,
        data:    payload || null,
      })
      .then(
        response => {
            //commit('setLogs', response);
            if(DEBUG) console.debug(`Store -> Dashboard adminCommand finished.`);
            return Promise.resolve(response);
        },
        error => {
            //commit('setLogs', {appLog: [], wrkLog: []});
            commit('setErrorMessage', error);
            return Promise.resolve(error);
        }
      );
    },
    

  },

  mutations: {
    setDB(state, tableData) {
        state.db = Array.isArray(tableData) ? tableData : [];
        state.isLoading = false;
    },
    setIsLoading(state, tf){
        state.isLoading = tf;
    },
    setSearchSPZ(state, spz){
        state.searchSPZ = spz;
    },
    setSearchOTHER(state, other){
        state.searchOTHER = other;
    },
    setFilter(state, num){
        state.filter = +num;
    },
    setDaysBack(state, num=0){
        state.daysBack = +num;
    },
    setTotalRecordCount(state, num=0){
        state.totalRecordCount = +num;
    },
    setErrorMessage(state, err){
        state.errorMessage = err;
    },
    setTabControl(state, tabc){
        state.tabControl.offset = tabc.offset || 0;
        state.tabControl.limit  = tabc.limit  || 10;
        state.tabControl.order  = tabc.order  || 'id';
        state.tabControl.sort   = tabc.sort   || 'desc';
    },
    setDashID(state, id){
        state.dashID = id;
    },
    setAction(state, action){
        state.action = action;
    },
    setCategoryCheck(state, payload){
        state.categoryCheck = { ...state.categoryCheck, ...payload };
    },
    setLogs(state, logs){
        state.appLog = logs.appLog;
        state.wrkLog = logs.wrkLog;
        //wrkLog =>  [ {workerID: 2, logs: [{dummyWrkLogRow]},...}, {workerID: 1, logs:[]} ]
    },

  }
};
